/* eslint-disable max-lines */
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

function usePropertyManagerFilter({
    onChange = () => {},
}: {
    onChange?: () => void;
} = {}) {
    const [searchParams, setSearchParams] = useSearchParams();

    const setPropertyManager = (propertyManager: string | null) => {
        setSearchParams(
            (params) => {
                if (propertyManager === null) {
                    params.delete('property-manager');
                    return params;
                }

                params.set('property-manager', propertyManager);

                return params;
            },
            {
                replace: true,
            }
        );

        onChange();
    };

    const propertyManager = useMemo(() => searchParams.get('property-manager'), [searchParams]);

    return {
        propertyManager,
        setPropertyManager,
    };
}

export { usePropertyManagerFilter };
